import React from "react";
import CustomizerComponent from "@gc-npm/components.customizer-component";
import Card from "@/home_components/card";

const Banner = ({ bannerProps, activityNames, scLogged }) => {
  const { stamps } = bannerProps;
  const sizes = "(min-width: 768px) 30vw, 98vw";
  return (
    <section className="container banner-cards" data-cy="Section heros">
      <div className="banner-cards--content">
        <div className="banner-cards--content_card banner-cards--content_card--one">
          {scLogged && (
            <CustomizerComponent
              name={activityNames[0]}
              Component={Card}
              componentProps={{ ...bannerProps[0], setPriority: "true" }}
              commonProps={{ custoStamps: stamps, setPriority: "true", sizes: sizes }}
              componentName="BannerCardHero1"
              skeletonClassName="skeleton-banner-card"
            />
          )}
          {!scLogged && (
            <Card  {...bannerProps[0]} setPriority="true" sizes={sizes}/>
          )}
        </div>
        <div className="banner-cards--content_card banner-cards--content_card--two">
          {scLogged && (
            <CustomizerComponent
              name={activityNames[1]}
              Component={Card}
              componentProps={{ ...bannerProps[1], setPriority: "false" }}
              commonProps={{ custoStamps: stamps, setPriority: "false" , sizes: sizes }}
              componentName="BannerCardHero2"
              skeletonClassName="skeleton-banner-card"
            />
          )}
          {!scLogged && (
            <Card  {...bannerProps[1]} setPriority="true" sizes={sizes}/>
          )}
        </div>
        <div className="banner-cards--content_card banner-cards--content_card--three">
          {scLogged && (
            <CustomizerComponent
              name={activityNames[2]}
              Component={Card}
              componentProps={{ ...bannerProps[2], setPriority: "false" }}
              commonProps={{ custoStamps: stamps, setPriority: "false", sizes: sizes }}
              componentName="BannerCardHero3"
              skeletonClassName="skeleton-banner-card"
            />
          )}
          {!scLogged && (
            <Card  {...bannerProps[2]} setPriority="true" sizes={sizes}/>
          )}
        </div>
      </div>
      <style jsx>
        {`.banner-cards {
  padding-top: 0.75rem;
  /* Tablet */
}
.banner-cards :global(a):focus-visible {
  outline-offset: 0.125rem;
}
.banner-cards :global(.price.price-layout--default) {
  display: inline-block;
  margin-right: 0.5rem;
}
.banner-cards :global(.price.price-layout--compact) {
  display: inline-flex;
  margin-right: 0.5rem;
}
.banner-cards :global(.price--post-price) {
  margin-top: 0.5rem;
}
.banner-cards :global(.card.layout-product .card-container--label) {
  min-height: auto;
}
.banner-cards :global(.card.layout-product .card-container) {
  flex-direction: column;
  justify-content: flex-start;
}
.banner-cards :global(.card.layout-product .card-content--price) {
  
}
.banner-cards :global(.card.layout-dispo-product .card-container) {
  flex-direction: column;
}
.banner-cards :global(.card.layout-dispo-product .card-container--label) :global(.label) {
  margin-bottom: 0.25rem;
}
.banner-cards :global(.card.layout-dispo-product .card-content--price) {
  
}
.banner-cards :global(.card.layout-dispo-product) {
  padding: 5%;
}
.banner-cards :global(.card) {
  padding: 0;
}
.banner-cards :global(.card) :global(.card-container) {
  gap: 0;
}
.banner-cards :global(.card) :global(.card-container--image .custom-image) {
  border-radius: 0;
}
.banner-cards :global(.card) :global(.card-container--info) {
  padding: 5%;
  gap: 0.5rem;
}
.banner-cards :global(.card) :global(.card-container--image) {
  max-width: none;
  aspect-ratio: unset;
  padding-top: 75%;
}
.banner-cards :global(.card) :global(.card-container--stamp) {
  padding: 0 1rem;
}
@media screen and (max-width: 768px) {
  .banner-cards :global(.layout-capta.card) :global(.card-container--image) {
    max-width: none;
    aspect-ratio: unset;
    padding-top: 0%;
  }
  .banner-cards :global(.layout-capta.card) :global(.card-container--image) :global(img) {
    position: relative !important;
  }
  .banner-cards :global(.layout-capta.card) :global(.card-container--info) {
    display: none;
  }
}
.banner-cards :global(.card.layout-dispo-product .card-container--info) {
  padding: 0;
}
.banner-cards--content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 auto;
  justify-content: space-between;
  gap: 1rem;
  padding-bottom:0.75rem;
}
.banner-cards--content_card {
  padding: 0;
  position: relative;
  display: flex;
  width: 100%;
}
.banner-cards--content--two, .banner-cards--content--three {
  display: none !important;
}
.banner-cards :global(.card-container--stamp) :global(img) {
  scale: 1;
}
@media screen and (min-width: 768px) {
  .banner-cards {
    margin: 0 auto;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .banner-cards :global(.card.layout-product .card-header--pretitle) {
    display: block;
  }
  .banner-cards :global(.card.layout-product .card-header--subtitle) {
    display: block;
  }
  .banner-cards :global(.card.layout-product .card-content--price) {
    display: block;
  }
  .banner-cards :global(.card.layout-dispo-product .card-content--price) {
    display: block;
  }
  .banner-cards--content {
    flex-wrap: nowrap;
    gap: 1rem;
  }
  .banner-cards :global(.card-container--stamp) :global(img) {
    scale: 1.5;
  }
}
@media screen and (min-width: 1280px) {
  .banner-cards {
    margin: 0 auto;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .banner-cards--content {
    flex-wrap: nowrap;
    gap: 1.5rem;
  }
}

@media screen and (max-width: 768px) {
  :global(.label) {
    padding: 0.25rem 0.55rem;
  }
}`}
      </style>
    </section>
  );
};

export default Banner;
